/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ACCOUNT EDIT USER : STYLES --------------- ++++++++++ */
export default theme => ({
    edituser: {
    	extend: theme.modal.form,
        maxWidth: pxToEm(849),
        '& .permissionslabel':{
            marginBottom: pxToEm(15)
        }
    }
});
